<template>
  <div class="create-ques-form">
    <div style="width: 48%">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="标题：" prop="name">
          <a-input v-model="form.name" type="textarea" />
        </a-form-model-item>
        <a-form-model-item label="简介：" prop="remark">
          <a-textarea v-model="form.remark" :rows="4" type="textarea" />
        </a-form-model-item>
        <a-form-model-item label="测评类型：" prop="remark">
          <j-dict-select-tag
            placeholder="请选择测评类型"
            v-model="form.type"
            dictCode="evaluation_type"
            allowClear
            @select="selectType"
          />
        </a-form-model-item>
        <a-form-model-item label="题目数量">
          <a-input-number v-model="form.num" placeholder="请输入题目数量" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="推荐用时">
          <a-input-number v-model="form.time" placeholder="请输入推荐用时" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="指标项信息：" prop="indexItem">
          <div class="index-item">
            <a-input
              v-model="form.indexItem"
              placeholder="请输入指标项"
              @pressEnter="addIndexItem"
            />
            <a-button type="dashed" block style="margin-top: 30px" @click="addIndexItem">
              <a-icon type="plus" />
              新增指标项
            </a-button>
          </div>
        </a-form-model-item>
        <a-form-model-item style="display: flex; justify-content: flex-end">
          <div>
            <a-popconfirm ok-text="是" cancel-text="否" @confirm="confirmCancel" @cancel="cancel">
              <template slot="title">
                <p>新增问卷模式下，取消操作会导致未保存的表单内容丢失</p>
                <p>确认要取消吗？</p>
              </template>
              <a-button>取消</a-button>
            </a-popconfirm>
            <a-button type="primary" style="margin: 0px 12px" @click="saveForm">保存</a-button>
            <a-button @click="nextClick">下一步</a-button>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
    <a-divider type="vertical" style="height: 600px" />
    <div style="width: 48%">
      <div style="margin: 10px 0">
        <a-button type="danger" ghost :disabled="!selectedRowKeys.length" @click="batchDeleteRow">
          批量删除
        </a-button>
      </div>
      <a-table
        rowKey="index"
        :columns="columns"
        :data-source="tableData"
        :scroll="{ y: 500 }"
        :pagination="pagination"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        bordered
      >
        <div slot="operation" slot-scope="text, record, index" style="cursor: pointer">
          <span style="color: #1890ff" @click="editRow(record, index)">编辑</span>
          <a-divider type="vertical" />
          <span @click="deleteRow(record, index)" style="color: #f81d22">删除</span>
        </div>
      </a-table>
    </div>
    <EditModal ref="editModalRef" @updateRow="updateRow" />
  </div>
</template>

<script>
import router from '@/router/index'
import EditModal from './components/EditModal'
import { postAction, putAction } from '@/api/manage'

export default {
  name: 'CreateQuesForm',
  components: {
    EditModal,
  },
  props: {
    quesData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      layout: 'horizontal',
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      form: {
        pageNo: 1,
        pageSize: 10,
      },
      rules: {
        name: [{ required: true, message: '请输入标题内容', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入简介内容', trigger: 'blur' }],
        // indexItem: [{ required: true, message: '请输入指标项内容', trigger: 'blur' }],
      },
      // 列表
      tableData: [],
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
          width: 80,
        },
        {
          title: '指标项',
          dataIndex: 'name',
          align: 'center',
        },
        // {
        //   title: '描述',
        //   dataIndex: 'suggestion',
        //   align: 'center',
        //   customRender: (_, record) => {
        //     const suggLen = record.suggestion.length
        //     return (
        //       <a-tooltip placement="top">
        //         {suggLen >= 40 && <template slot="title">{record.suggestion}</template>}
        //         <span>
        //           {suggLen >= 40 ? record.suggestion.substring(0, 40) + '...' : record.suggestion}
        //         </span>
        //       </a-tooltip>
        //     )
        //   },
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
        },
      ],
      pagination: {
        // current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        // showQuickJumper: true,
        showSizeChanger: true,
      },
      selectedRowKeys: [],
      evaluationId: '',
    }
  },
  watch: {
    quesData: {
      handler(newVal) {
        console.log('quesData变化--', newVal)
        if (Object.keys(newVal).length) {
          this.initInfo()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initInfo() {
      // console.log('初始化--', this.quesData)
      if (Object.keys(this.quesData).length) {
        this.form = {
          name: this.quesData.name,
          remark: this.quesData.remark,
          type: this.quesData.type,
          num: this.quesData.num,
          time: this.quesData.time,
        }
        this.tableData = this.quesData.evaluationPointList.map((item, index) => ({
          ...item,
          index: index + 1,
        }))
      }
    },
    selectType(value) {
      this.form.type = this.form.type ? [...this.form.type, ...value] : value
    },
    saveForm() {
      const evaluationPointList = this.tableData.map((item) => ({
        id: item.id || '',
        name: item.name || '',
        suggestion: item.suggestion || '',
      }))
      const params = {
        ...this.form,
        evaluationPointList,
      }
      // 编辑
      if (Object.keys(this.quesData).length) {
        putAction('/schoolEvaluation/edit', { id: this.quesData.id, ...params }).then((res) => {
          if (res.success) {
            this.$message.success('更新成功')
            this.$emit('refreshQuesData')
          }
        })
        return
      }
      // 新增
      postAction('/schoolEvaluation/add', params).then((res) => {
        if (res.success) {
          this.$message.success('创建成功')
          this.evaluationId = res.result
          this.$emit('refreshQuesData', this.evaluationId)
        }
      })
    },
    confirmCancel() {
      router.go(-1)
    },
    cancel() {},
    addIndexItem() {
      if (!this.form.indexItem) {
        this.$message.error('请输入指标项内容')
        return
      }
      this.tableData.push({
        index: this.tableData.length + 1,
        id: '',
        name: this.form.indexItem,
        suggestion: this.form.suggestion,
      })
      this.$message.success('指标项添加成功')
      this.saveForm()
      this.$set(this.form, 'indexItem', undefined)
      this.$set(this.form, 'suggestion', undefined)
    },
    nextClick() {
      this.$emit('nextClick', this.evaluationId)
    },
    editRow(record, index) {
      this.$refs.editModalRef.showModal(record, index)
    },
    updateRow(data, index) {
      this.$set(this.tableData, index, data)
      this.saveForm()
    },
    deleteRow(index) {
      this.tableData.splice(index, 1)
      this.saveForm()
    },
    batchDeleteRow() {
      this.tableData = this.tableData.filter((item, index) => !this.selectedRowKeys.includes(index))
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
  },
}
</script>
<style scoped lang="less">
.create-ques-form {
  height: 100%;
  display: flex;
  justify-content: space-between;
  .index-item {
    display: flex;
    flex-direction: column;
    padding: 30px 20px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    overflow: hidden;
  }
}
.input-btn {
  display: inline-block;
  padding: 2px 5px;
  color: #1890ff;
  cursor: pointer;
}
</style>
